import {i18n} from '@online-offer/i18n';
import {Grid, GridItem, Show, useResponsivePropValue, VStack} from 'platform/foundation';
import {useLocale} from 'platform/locale';

import {isNotNil} from 'ramda';

import {CommentExpandable} from '../../components/CommentExpandable/CommentExpandable';
import {DataColumn} from '../../components/DataColumn/DataColumn';
import {Section} from '../../components/Section/Section';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {canShowWarranty} from './utils/canShowWarranty';
import {getWarrantyTermsForLanguage} from './utils/getWarrantyTermsForLanguage';

export function Warranty() {
  const {warrantyDuration, warrantyTermsAndConditions} = useGetOnlineOfferData();
  const {language} = useLocale();
  const gridColumns = useResponsivePropValue([1, 2]);
  const termsText = getWarrantyTermsForLanguage(warrantyTermsAndConditions, language);

  return (
    <Show when={canShowWarranty(warrantyDuration, termsText)}>
      <Section id="WARRANTY" isWithBreakLine data-testid="warranty">
        <VStack spacing={4}>
          <Show when={isNotNil(warrantyDuration)}>
            <Grid columns={gridColumns} spacing={[0, 8]}>
              <GridItem>
                <DataColumn
                  data={[
                    {
                      label: i18n.t('warranty.defaultDuration'),
                      value: warrantyDuration,
                    },
                  ]}
                />
              </GridItem>
            </Grid>
          </Show>
          <Show when={isNotNil(termsText)}>
            <CommentExpandable
              hideCommentFlag
              comment={termsText}
              data-testid="warranty-termsAndConditions"
            />
          </Show>
        </VStack>
      </Section>
    </Show>
  );
}
